const checkbox = document.getElementById('cart-express-checkbox');
const variantId = parseInt(checkbox.dataset.variantId, 10);
let isProcessing = false;

checkbox.addEventListener('change', async function() {
  if (isProcessing) return;
  isProcessing = true;

  try {
    if (this.checked) {
      await addCartItem({id: variantId, quantity: 1});
      window.location.href = window.location.href;
    } else {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      const foundItem = cart.items.find(item => item.variant_id === variantId);

      if (foundItem) {
        await setCartItemQuantity(foundItem.key, 0);
        window.location.href = window.location.href;
      }
    }
  } catch (error) {
    console.error('Error updating cart:', error);
    this.checked = !this.checked;
  } finally {
    isProcessing = false;
  }
});

async function addCartItem(cartItem) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(cartItem)
  });
  if (response.ok) {
    return await response.json();
  }

  return null;
}

async function setCartItemQuantity(key, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({id: key, quantity: quantity})
  });

  if (response.ok) {
    return await response.json();
  }

  return null;
}
